/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAlertAssignment,
    InternalApiAlertAssignmentFromJSON,
    InternalApiAlertAssignmentToJSON,
    InternalApiAlertAssignmentCommand,
    InternalApiAlertAssignmentCommandFromJSON,
    InternalApiAlertAssignmentCommandToJSON,
    InternalApiAlertType,
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeToJSON,
} from '../models';

export interface AssignAlertRequest {
    internalApiAlertAssignmentCommand: InternalApiAlertAssignmentCommand;
}

export interface GetAllAssignmentsRequest {
    alertId: number;
    alertType: InternalApiAlertType;
}

export interface UnassignAlertRequest {
    internalApiAlertAssignmentCommand: InternalApiAlertAssignmentCommand;
}

/**
 * 
 */
export class AlertAssignmentApi extends runtime.BaseAPI {

    /**
     * Assigns screening and monitoring alert
     */
    async assignAlertRaw(requestParameters: AssignAlertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiAlertAssignmentCommand === null || requestParameters.internalApiAlertAssignmentCommand === undefined) {
            throw new runtime.RequiredError('internalApiAlertAssignmentCommand','Required parameter requestParameters.internalApiAlertAssignmentCommand was null or undefined when calling assignAlert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alerts/assign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiAlertAssignmentCommandToJSON(requestParameters.internalApiAlertAssignmentCommand),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Assigns screening and monitoring alert
     */
    async assignAlert(requestParameters: AssignAlertRequest, initOverrides?: RequestInit): Promise<void> {
        await this.assignAlertRaw(requestParameters, initOverrides);
    }

    /**
     * Get all alert status events for alert
     */
    async getAllAssignmentsRaw(requestParameters: GetAllAssignmentsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiAlertAssignment>>> {
        if (requestParameters.alertId === null || requestParameters.alertId === undefined) {
            throw new runtime.RequiredError('alertId','Required parameter requestParameters.alertId was null or undefined when calling getAllAssignments.');
        }

        if (requestParameters.alertType === null || requestParameters.alertType === undefined) {
            throw new runtime.RequiredError('alertType','Required parameter requestParameters.alertType was null or undefined when calling getAllAssignments.');
        }

        const queryParameters: any = {};

        if (requestParameters.alertId !== undefined) {
            queryParameters['alertId'] = requestParameters.alertId;
        }

        if (requestParameters.alertType !== undefined) {
            queryParameters['alertType'] = requestParameters.alertType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alerts/assign`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiAlertAssignmentFromJSON));
    }

    /**
     * Get all alert status events for alert
     */
    async getAllAssignments(requestParameters: GetAllAssignmentsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiAlertAssignment>> {
        const response = await this.getAllAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Un-assign screening and monitoring alert
     */
    async unassignAlertRaw(requestParameters: UnassignAlertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiAlertAssignmentCommand === null || requestParameters.internalApiAlertAssignmentCommand === undefined) {
            throw new runtime.RequiredError('internalApiAlertAssignmentCommand','Required parameter requestParameters.internalApiAlertAssignmentCommand was null or undefined when calling unassignAlert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alerts/assign`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiAlertAssignmentCommandToJSON(requestParameters.internalApiAlertAssignmentCommand),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Un-assign screening and monitoring alert
     */
    async unassignAlert(requestParameters: UnassignAlertRequest, initOverrides?: RequestInit): Promise<void> {
        await this.unassignAlertRaw(requestParameters, initOverrides);
    }

}
